import { VALIDATION_PENDING, VALIDATED, LOCKED } from '@/lib/enums/user/status'
import Option from '@/lib/transfer-objects/Option'
import Filter from '@/lib/transfer-objects/Filter'

const keyValues = {
  [VALIDATION_PENDING]: 'En attente de validation',
  [VALIDATED]: 'Validé',
  [LOCKED]: 'Bloqué'
}
var options = []
for (var key in keyValues) {
  options.push(new Option(keyValues[key], key))
}
var filter = new Filter({options: options})

export {keyValues as userStatus, filter as userStatusFilter}



// WEBPACK FOOTER //
// ./src/lib/filters/user/status.js